<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            <br /> {{ creditor.creditor_name }}
            <br /> 
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
            <br />
            <br /> Date: {{ date }}
        </p>
        <p> RE: Account # {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }} </p>
        <p> To Whom It May Concern: </p>
        <p class="letter-content">
            This is my second letter requesting that your company correct your own mistakes. I have received no response from you and yet you continue to report to the credit bureaus, even verifying this account to them when I dispute it. I am well aware that is a violation of the Fair Credit Reporting Act to continue to report information on an account in dispute, especially when you have failed, per the FCRA and FCBA, to verify the account with documented proof. Therefore, I am humbly requesting, once again, that you either verify this account by providing the following information or you delete it completely with any and all credit bureaus in which you are reporting to.
        </p>
        <ul>
            <li class="letter-content">
                A detailed and itemized statement of ALL activity to this account, including the contract I must have allegedly signed to bind me to this debt;
                <br>
            </li>
            <li class="letter-content">
                The photo identification I must have provided at the time of starting services with you in order for you to assure that this was not an attempt of someone else to commit a fraud against me as required by the Patriot Act (You do take these precautions correct?)
                <br>
            </li>
            <li class="letter-content">
                An itemized statement breaking down the balance you claim I owe; and<br>
            </li>
            <li class="letter-content">
                Any other documentation you must have in order to truthfully make a notarized statement on your letterhead, attesting to your compliance of the FCBA.
                <br>
            </li>
        </ul>
        <p class="letter-content">
            I expect a reasonable response with sufficient verification per the law from you within the next 15 days of receipt of this letter or I will be forced to file a complaint with the Federal Trade Commission and all governing bodies to protect and rightfully correct my credit information from inaccurate and erroneous reporting.
        </p>
        <p>
            Thank you for your time and attention to this matter.
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>